<template>
  <!-- eslint-disbale -->
  <div id="app" >
    <router-view />
  </div>
</template>
<script>
export default {
  components: {
    // Style,
  },
};
</script>
 
<style lang="scss">
@import "@/assets/Styling.css";
@import url("https://fonts.googleapis.com/css2?family=Sora:wght@400;500;700&display=swap");

#app {
  font-family: Sora, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: start;
  color: #2c3e50;
}
</style>

